import { Component, OnInit } from '@angular/core';
import { MatDialog} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AddConfigComponent } from '../add-config/add-config.component';
import { logbaseService } from './../../services/logbase.service';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss']
})
export class ConfigurationComponent implements OnInit {


  ELEMENT_DATA: Element[];
  dataSource: any[];
  displayedColumns: any[];

  constructor(public dialog: MatDialog, private logbaseService: logbaseService,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.getNoubaPattern()
  }

  getNoubaPattern() {
    this.spinner.show();
    this.logbaseService.getNoubaPattern().subscribe(result => {
      this.displayedColumns = ['id', 'noubaCodePattern', 'edit'];
      const data = result.response
      console.log(data)
      this.dataSource = data;
      this.spinner.hide();
    })
  }

  onClickConfig(element: any) {
    let dialogRef = this.dialog.open(AddConfigComponent, {
      width: '400px',
      height:'350px',
      disableClose: true,
      data: { payload: element, type: 'editNoubaPattern' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != 'Close')
        this.getNoubaPattern();
    })
  }


  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    // this.dataSource.filter = filterValue;
  }

}

export interface Element {
  nouba: string;
  position: number;
  condition: string;
  suppliercode: string;
}

